// extracted by mini-css-extract-plugin
export default {"figure":"jQqmHJWkq2RB9y5axXeR","title":"f5z1bgyyg3YVhQ_dOm3i","subtitle":"xQbCxZ7YqyJ42L0G67tl","card":"H5oAvTSYYF5k9Yn06jP8","cds--tile":"nce6sPY6qxeshefPqlB2"};